import * as Yup from "yup";

const Validation = Yup.object({

  name: Yup.string().required("Please enter name!"),
  // language: Yup.string().required("Please enter content!"),
});

export default Validation;